export enum Status {
    NotDefined,
    Approved,
    Disapproved,
}
